import z from "zod";
import { zOrderPhotosTimeTypeSchema } from "./common";
export const zOrderPhotosSchemaDto = z.object({
    id: z.string(),
    order_id: z.string(),
    image_urls: z.string().array(),
    time_type: zOrderPhotosTimeTypeSchema,
});
